import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PayTabsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { PayTabsReportApi } from '../api/paytabs-report-api';
import { PayTabsReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class PayTabsReportRepository extends Repository {
  constructor(private payTabsReportApi: PayTabsReportApi) {
    super();
  }

  getPayTabsReport(filter: PayTabsReportFilterForm): Observable<DataWithPagination<PayTabsReport[]>> {
    return this.payTabsReportApi.getPayTabsReport(filter);
  }
}
